import { render, staticRenderFns } from "./Mbutton.vue?vue&type=template&id=b2e6483a&scoped=true"
import script from "./Mbutton.vue?vue&type=script&lang=js"
export * from "./Mbutton.vue?vue&type=script&lang=js"
import style0 from "./Mbutton.vue?vue&type=style&index=0&id=b2e6483a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e6483a",
  null
  
)

export default component.exports